const removeCurrentSectionOption = options => {
    const currentUri = window.location.pathname;

    return options.filter(({link}) => link !== currentUri);
}

module.exports = {
    removeCurrentSectionOption
}